import type { AppCategory } from "../AppsSidebar/types";

/**
 * Filtra el catálogo por texto y por sección.
 *
 * Va aparte del componente porque es la única parte con reglas que se pueden
 * equivocar —acentos, mayúsculas, categorías que se quedan vacías— y así se
 * prueba sin montar un menú entero.
 */

/**
 * «Mantenimiento» tiene que encontrarse escribiendo «mantenimiento», y
 * «Patio de Maniobras» escribiendo «maniobras». Sin quitar los acentos, quien
 * escribe rápido o desde un teclado sin tildes no encuentra nada y concluye
 * que la app no existe.
 */
const normalizar = (s: string) =>
  s
    .toLowerCase()
    .normalize("NFD")
    .replace(/[̀-ͯ]/g, "");

export function filtrarApps(
  categorias: AppCategory[],
  texto: string,
  categoriaId: string | null,
): AppCategory[] {
  const q = normalizar(texto.trim());
  const porSeccion = categoriaId
    ? categorias.filter((c) => c.id === categoriaId)
    : categorias;

  if (!q) return porSeccion;

  return (
    porSeccion
      .map((c) => ({
        ...c,
        // Busca también en la descripción: alguien que no recuerda el nombre
        // sí recuerda para qué servía.
        apps: c.apps.filter(
          (a) =>
            normalizar(a.name).includes(q) ||
            normalizar(a.description ?? "").includes(q),
        ),
      }))
      // Una categoría sin resultados no se dibuja: un rótulo con nada debajo
      // se lee como un error de la app, no como «aquí no hay».
      .filter((c) => c.apps.length > 0)
  );
}
